export default function TableNoData() {
  return (
    <svg
      width="173"
      height="173"
      viewBox="0 0 173 173"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1209_12142)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M27.4825 63.0328C36.0275 42.7345 43.4253 17.9567 64.7757 12.5046C86.7795 6.88561 106.826 23.6834 124.186 38.3382C141.532 52.9813 161.47 69.9234 159.568 92.5259C157.726 114.43 134.145 125.248 115.849 137.435C99.501 148.325 82.4536 160.842 63.2391 156.695C43.3054 152.392 28.0882 135.969 20.8177 116.924C14.0228 99.1253 20.0945 80.5825 27.4825 63.0328Z"
          fill="#DEE9FF"
        />
        <path
          d="M27.9021 106.086C28.4175 105.791 34.2347 103.328 63.1739 116.819C63.0896 116.934 63.0538 116.988 63.0538 116.988C63.0538 116.988 32.9686 127.12 27.074 114.638C25.3138 110.923 25.8181 108.364 27.8519 106.115L27.9021 106.086Z"
          fill="#0E84E5"
        />
        <path
          d="M125.169 111.191C118.882 116.477 109.022 120.313 99.5078 115.211C101.011 114.251 102.564 113.261 104.148 112.238C113.702 106.099 122.118 110.206 125.169 111.191Z"
          fill="#0E84E5"
        />
        <path
          d="M136.431 46.1829C142.854 99.6725 127.589 109.38 125.889 110.855C125.397 111.282 125.198 111.251 124.454 111.059L124.441 111.066C121.293 110.232 113.702 106.099 104.148 112.237C102.564 113.26 101.01 114.25 99.5075 115.211C89.7607 121.392 81.8897 125.749 76.2192 123.22C71.4093 120.766 67.0725 118.643 63.1736 116.819C34.2344 103.328 28.4173 105.79 27.9019 106.085C28.4999 105.76 33.9859 102.719 41.3728 97.3711C41.3979 97.3567 41.4231 97.3423 41.4285 97.3226C51.302 90.1671 64.5247 78.8909 74.0292 64.3855C80.4995 54.5218 86.8293 29.5161 99.0423 24.6098C124.142 15.2462 135.389 35.3029 136.431 46.1829Z"
          fill="#699CFF"
        />
        <path
          d="M108.677 45.2445C109.457 43.1872 109.381 41.2514 108.508 40.9209C107.635 40.5903 106.296 41.9902 105.517 44.0475C104.738 46.1049 104.814 48.0407 105.686 48.3712C106.559 48.7017 107.898 47.3019 108.677 45.2445Z"
          fill="white"
        />
        <path
          d="M124.659 47.8694C125.211 45.7399 124.927 43.8237 124.023 43.5894C123.12 43.3551 121.94 44.8916 121.388 47.0211C120.835 49.1506 121.12 51.0669 122.024 51.3011C122.927 51.5354 124.107 49.999 124.659 47.8694Z"
          fill="white"
        />
        <path
          d="M114.931 55.6886C114.8 55.6884 114.673 55.6435 114.572 55.5613C114.47 55.4791 114.399 55.3646 114.371 55.2366C114.269 54.7734 113.814 53.4029 113.092 53.1992C112.37 52.9955 110.955 53.7864 110.382 54.2012C110.259 54.2905 110.105 54.3271 109.955 54.3031C109.805 54.2791 109.67 54.1963 109.581 54.073C109.492 53.9498 109.455 53.7961 109.479 53.6458C109.503 53.4955 109.586 53.3609 109.709 53.2716C109.935 53.1082 111.956 51.6862 113.404 52.0946C114.913 52.5206 115.438 54.7407 115.492 54.9925C115.511 55.0763 115.51 55.1632 115.49 55.2467C115.47 55.3302 115.432 55.4082 115.378 55.475C115.325 55.5417 115.256 55.5956 115.179 55.6326C115.102 55.6695 115.017 55.6887 114.931 55.6886H114.931Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1209_12142">
          <rect width="173" height="173" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
